import {BUSCAR_RESERVAS_ITINERARIO, LIMPAR_RESERVAS_ITINERARIO} from '../../actions/types'

const initialState = undefined

export default function reducerBuscarReservas(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_RESERVAS_ITINERARIO: {
            const reservas = action.payload.data;

            if (reservas) {
                return reservas
            }
            return []
        }

        case LIMPAR_RESERVAS_ITINERARIO: {
            return []
        }
        default: {
            return state
        }
    }
}
